import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import SvgIcon from '@material-ui/core/SvgIcon'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import IconButton from '@material-ui/core/IconButton'
import AccountCircle from '@material-ui/icons/AccountCircle'
import SettingsIcon from '@material-ui/icons/Settings'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import { Word } from '../../../containers'
import TweetListDialog from '../containers/TweetListDialog'
import { Link } from 'react-router-dom'
import { makePath } from '../../../lib';
import { WID } from '../../../constants/Language';
import { useContext } from 'react'
import { Auth0Context } from '../../Auth0'
import { SettingsContext } from '../../Settings'
import CustomAvatar from '../../CustomAvatar/CustomAvatar'

const styles = theme => ({
  profileMenuItem: {
    width: 250,
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
  },
  avatar: {
    width: theme.spacing.unit * 6,
    height: theme.spacing.unit * 6,
  },
  divider: {
    marginBottom: theme.spacing.unit,
  }
})

const UserMenu = (props) => {
  const {
    classes,
    open,
    user,
    settings,
    anchorEl,
    handleClickMenu,
    handleClose,
    handleTweetListDialog,
  } = props

  const auth0Context = useContext(Auth0Context)

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext
  
  const handleLogOut = () => {
    auth0Context.logout()
    props.handleLogOut()
  }

  return (
    <React.Fragment>
      {user && settings && (
        <React.Fragment>
          <IconButton
            aria-owns={open ? 'menu-appbar' : null}
            aria-haspopup="true"
            onClick={handleClickMenu}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={open}
            onClose={handleClose}
          >
            {settings && settings.userName && (
              <MenuItem className={classes.profileMenuItem} component={Link} to={makePath(`/user/${settings.userName}`, language)} onClick={handleClose}>
                <ListItemAvatar>
                  <CustomAvatar
                    alt={user.sub}
                    name={settings.displayName}
                    src={settings.avatarPhotoURL ? settings.avatarPhotoURL : user.picture}
                    className={classes.avatar}
                  />
                </ListItemAvatar>
                <ListItemText primary={settings.displayName} secondary={`@${settings.userName}`}/>
              </MenuItem>
            )}
            {user && user.sub.match('twitter') && (
              <MenuItem
                onClick={(event) => {
                  handleTweetListDialog()
                  handleClose()
                }}
              >
                <ListItemIcon>
                  <SvgIcon viewBox="-20 -20 140 140" >
                    <path d="M31.45,90.64c37.74,0,58.37-31.27,58.37-58.38,0-.89,0-1.77-.06-2.65A41.86,41.86,0,0,0,100,19a41.19,41.19,0,0,1-11.78,3.23,20.6,20.6,0,0,0,9-11.35,41.11,41.11,0,0,1-13,5,20.54,20.54,0,0,0-35,18.71A58.25,58.25,0,0,1,7,13.12a20.53,20.53,0,0,0,6.35,27.39A20.29,20.29,0,0,1,4,37.94a2.44,2.44,0,0,0,0,.27A20.53,20.53,0,0,0,20.47,58.32a20.49,20.49,0,0,1-9.26.35A20.54,20.54,0,0,0,30.38,72.92,41.21,41.21,0,0,1,4.89,81.7,41.69,41.69,0,0,1,0,81.42a58.07,58.07,0,0,0,31.45,9.22" />
                  </SvgIcon>
                </ListItemIcon>
                <ListItemText primary={<Word wid={WID.USER_MENU.SCHEDULE_TWEET}/>} />
              </MenuItem>
            )}
            <MenuItem component={Link} to={makePath(`/settings`, language)} onClick={handleClose}>
              <ListItemIcon>
                <SettingsIcon/>
              </ListItemIcon>
              <ListItemText primary={<Word wid={WID.USER_MENU.SETTINGS}/>}/>
            </MenuItem>
            <MenuItem onClick={() => {
              handleLogOut()
              handleClose()
            }}>
              <ListItemIcon>
                <ExitToAppIcon/>
              </ListItemIcon>
              <ListItemText primary={<Word wid={WID.USER_MENU.LOGOUT}/>}/>
            </MenuItem>
          </Menu>
        </React.Fragment>
      )}
      <TweetListDialog/>
    </React.Fragment>
  )
}

export default withStyles(styles, { withTheme: true })(UserMenu)



// WEBPACK FOOTER //
// ./src/Parts/MenuAppBar/components/UserMenu.js